import { useRef, useCallback, useEffect } from 'react';
import isAbortErrorHelper from 'src/js/modules/utils/is-abort-error';

function useAbortController() {
  const abortControllerRef = useRef(null);

  const getAbortController = useCallback(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    return controller;
  }, []);

  const getCurrentAbortController = useCallback(() => abortControllerRef.current, []);

  const isAbortError = useCallback((error) => isAbortErrorHelper(error), []);

  useEffect(
    () => () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    },
    []
  );

  return {
    getAbortController,
    getCurrentAbortController,
    isAbortError,
  };
}

export default useAbortController;
